export const SITE = {
	siteName: "Sean Tsang",
	defaultTitle: "Sean Tsang - Senior Analyst Programmer",
	siteUrl: "https://seantsang.site",
	defaultDescription:
		"Senior Analyst Programmer specializing in React, TypeScript, Next.js, cloud architecture, and automation engineering.",
	defaultKeywords: [
		"Sean Tsang",
		"Senior Analyst Programmer",
		"Software Engineer",
		"React",
		"TypeScript",
		"AWS",
	],
	defaultImage: "/homepage.jpg",
	twitterHandle: "",
};

const SEO = {
	home: {
		title: "Sean Tsang - Senior Analyst Programmer",
		description:
			"Portfolio of Sean Tsang, Senior Analyst Programmer, featuring full-stack projects, cloud solutions, and software engineering achievements.",
		keywords: [
			"Sean Tsang",
			"Senior Analyst Programmer",
			"Full-Stack Developer",
			"React Portfolio",
		],
		path: "/",
	},
	about: {
		title: "About | Sean Tsang",
		description:
			"Learn more about Sean Tsang, a software engineer and cellist passionate about technology, teamwork, and continuous growth.",
		keywords: ["About Sean Tsang", "Software Engineer", "Cellist"],
		path: "/about",
	},
	projects: {
		title: "Projects | Sean Tsang",
		description:
			"Explore projects built across 5 years of IT experience, from web development and automation to cloud-native solutions.",
		keywords: [
			"Sean Tsang Projects",
			"React Projects",
			"Automation",
			"AWS",
		],
		path: "/projects",
	},
	achievements: {
		title: "Achievements | Sean Tsang",
		description:
			"Professional certifications and milestones, including AWS, ServiceNow, and Azure AI achievements.",
		keywords: ["Certifications", "AWS", "Azure AI", "ServiceNow"],
		path: "/achievement",
	},
	contact: {
		title: "Contact | Sean Tsang",
		description:
			"Get in touch with Sean Tsang for software engineering opportunities, collaborations, and professional networking.",
		keywords: ["Contact Sean Tsang", "Collaboration", "Software Engineer"],
		path: "/contact",
	},
	notFound: {
		title: "404 | Sean Tsang",
		description: "The requested page could not be found.",
		keywords: ["404", "Not Found"],
		path: "/404",
		noIndex: true,
	},
};

export const getPageSeo = page => SEO[page] || null;

export default SEO;
